/// <amd-module name="TFS/Admin/Groups/Pivots/Users/Components/UsersPivot" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IPivotProps } from "TFS/Admin/Groups/Common/Contracts";
import { ConnectedUsersPivotInitializer } from "TFS/Admin/Groups/Pivots/Users/Components/UsersPivotInitializer";

export class UsersPivot extends VssComponent<IPivotProps> {

    constructor(props: IPivotProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return <ConnectedUsersPivotInitializer filter={this.props.filter} pageContext={this.context.pageContext} />;
    }
}

VssComponent.register("ms.vss-admin-web.orggroups-user-pivot", UsersPivot);
